import axios from 'axios'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 60000
})

service.interceptors.request.use(
  config => {
    if (localStorage.getItem('x-auth-token')) {
      config.headers['x-auth-token'] = localStorage.getItem('x-auth-token')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.headers['x-auth-token']) {
      localStorage.setItem('x-auth-token', response.headers['x-auth-token'])
    }
    return response.data
  },
  error => {
    if (error && error.code && error.code == 'ECONNABORTED') {
      return Promise.reject('网络超时')
    }
    if (error && error.response && error.response.status && error.response.data && error.response.data.status && error.response.data.error) {
      switch (error.response.data.status) {
        case 403:
          localStorage.removeItem('x-auth-token')
          return router.replace('/login')
          break
        case 500:
          return Promise.reject('操作失败')
          break
        case 404:
          return Promise.reject('系统出现了一个错误')
          break
        default:
          return Promise.reject(error.response.data.error)
          break
      }
    }
    if (error && error.response && error.response.status) {
      switch (error.response.status) {
        case 403:
          localStorage.removeItem('x-auth-token')
          return router.replace('/login')
          break
        case 500:
          return Promise.reject(error.response.data)
          break
        case 404:
          return Promise.reject('系统出现了一个错误')
          break
        default:
          return Promise.reject(error.response.data || error.response.statusText || '操作异常')
          break
      }
    }
    if (error && error.response) {
      return Promise.reject(error.response)
    }
    return Promise.reject(error)
  }
)

export { service as request }


const fantyi = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_BAIDUFANYI,
  timeout: 40000
})

export { fantyi }


const weixin = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_WEIXIN,
  timeout: 40000
})

export { weixin }